<template>
  <div id="addressCenter">
    <div class="title">
      <p class="name">地址管理<span class="back" @click="back()" v-if="isApp!==2">返回<i class="backIcon">></i></span></p>
    </div>
    <div class="address-list-root">
      <div class="address-list-empty" v-show="addressList.length <= 0">暂无数据</div>
      <div class="address-list-layout" v-for="(item,index) in addressList" :key="index">
        <div class="flex-row ct">
          <span class="m-left address-list-name">{{item.name}}</span>
          <div class="flex"></div>
          <span class="m-right address-list-name">{{item.phone}}</span>
        </div>
        <div class="m-left m-right m-top m-bottom address-list-address">
          {{item.province}}{{item.city}}{{item.area}}{{item.address}}
        </div>
        <div class="line m-top"></div>
        <div class="address-list-item-edit-layout flex-row ct">
          <span class="m-left address-list-default-txt" v-show="item.is_default === 1">默认地址</span>
          <div class="flex" style="height: 100%"></div>
          <div class="line2"></div>
          <div class="address-list-item-wwlayout flex-row ct" v-on:click="updateAddress(item)">
            <img src="../images/ic_address_edit.png">
            <span>编辑</span>
          </div>
          <div class="line2"></div>
          <div class="address-list-item-wwlayout flex-row ct" v-on:click="delAddress(item,index)">
            <img src="../images/ic_address_del.png">
            <span>删除</span>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 20px"></div>
    <div class="address-list-bottom-layout" :style="{marginBottom: tabHeight+'px'}">
      <div class="line"></div>
      <button v-on:click="addAddress">新增地址</button>
    </div>
  </div>
</template>

<script>

import wxshare from '../../../wx/weixin'
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      addressList: [],
      tabHeight: 65,
      isApp : 0
    }
  },
  methods: {
    back () {
      this.$router.back(-1)
    },
    addAddress: function () {
      this.$router.push({
        path: '/editAddress',
        query: {
          editAddressType: 0
        }
      })
    },
    delAddress: function (item, index) {
      const that = this
      const param = {
        id: item.id
      }
      this.utils.POST(this.accountUrl + '/site/delete', param, (resultData) => {
        if (resultData.success) {
          that.addressList.splice(index, 1)
          Toast('删除成功')
        }
      })
    },
    updateAddress: function (item) {
      this.$router.push({
        path: '/editAddress',
        query: {
          editAddressType: 1,
          editAddressBean: item
        }
      })
    },
    getAddressListData: function () { // 获取地址列表数据
      const that = this
      this.utils.GET(this.accountUrl + '/site/list', (resultData) => {
        if (resultData.success) {
          if (resultData.data !== undefined && resultData.data !== null && resultData.data.length > 0) {
            that.addressList = resultData.data
          } else {
            Toast('暂无数据')
          }
        }
      })
    },
    androidTabHeight: function (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 5
        }
      } else {
        this.tabHeight = this.tabHeight + parseInt(value)
      }
    }
  },
  mounted () {
    wxshare.wxShareHomePage('【中消在线】消防安全产品一站式采购平台', '品质保障，正品低价，支持线上交易', 'http://cdn.zxzx119.com/1294196519632633856')
    this.getAddressListData()
    document.body.scrollTop = document.documentElement.scrollTop = 0 
    if(this.$route.query.isApp){
       this.isApp = parseInt(this.$route.query.isApp) 
       localStorage.setItem("isApp",this.isApp)
    }else if(localStorage.getItem('isApp')){
      this.isApp = parseInt(localStorage.getItem('isApp'));
    }
    if(this.isApp===2){
       this.utils.GET(this.companyUrl + '/ent/json',
          function (res) {
            localStorage.setItem('userinfo', JSON.stringify(res.data))
          })
    }
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || 
      parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  }
}
</script>

<style scoped>
#addressCenter {
  background: #f2f2f2;
  min-height: 100vh;
}
.title {
  height: 50px;
  line-height: 50px;
  width: 100%;
  padding: 0 13px 0 13px;
  background: #ffffff;
  position: fixed;
  top: 0;
  z-index: 2;
  border-bottom-style: solid;
  border-bottom-color: #f2f2f2;
  border-bottom-width: 1px;
}
.name {
  font-size: 15px;
  color: #000000;
  font-weight: bold;
}
.back {
  float: right;
  font-size: 13px;
  color: #999999;
}
.backIcon {
  display: inline-block;
  vertical-align: top;
  margin-left: 5px;
  font-size: 13px;
  color: #999999;
}
/*body {*/
/*  background: #f2f2f2;*/
/*}*/
.flex-row {
  display: flex;
  flex-direction: row;
}
.ct {
  align-items: center;
  justify-content: center;
}
.flex {
  flex: 1;
}
.line {
  background: #f2f2f2;
  width: 100%;
  height: 1px;
}
.line2 {
  background: #f2f2f2;
  height: 100%;
  width: 1px;
}
.m-top {
  margin-top: 7px;
}
.m-bottom {
  margin-bottom: 12px;
}
.m-left {
  margin-left: 13px;
}
.m-right {
  margin-right: 13px;
}
.address-list-root {
  position: relative;
  top: 50px;
  margin-bottom: 80px;
}
.address-list-empty {
  width: 100%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  font-size: 12px;
  color: #999999;
}
.address-list-layout {
  width: 100%;
  background: white;
  padding-top: 13px;
  margin-top: 15px;
}
.address-list-name {
  color: black;
  font-size: 16px;
}
.address-list-address {
  font-size: 12px;
  color: #808080;
}
.address-list-item-edit-layout {
  width: 100%;
  height: 45px;
}
.address-list-default-txt {
  font-size: 14px;
  color: #c41335;
}
.address-list-item-wwlayout {
  width: 80px;
  color: #808080;
  font-size: 14px;
}
.address-list-item-wwlayout img {
  width: 13px;
  height: 13px;
  margin-right: 5px;
}
.address-list-bottom-layout {
  width: 100%;
  height: 65px;
  position: fixed;
  bottom: 0;
  background: white;
}
.address-list-bottom-layout div {
  position: absolute;
  top: 0;
}
.address-list-bottom-layout button {
  width: calc(100% - 13px * 2);
  height: 45px;
  position: relative;
  top: 10px;
  outline: none;
  background: #c41335;
  color: white;
  font-size: 15px;
  border-radius: 4px;
  margin-left: 13px;
  margin-right: 13px;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/personCenter/addressCenter.vue